/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=a0d83fd4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=a0d83fd4&lang=scss"

import exportComponent from "/Users/research/Downloads/化小北前端源码-24-11-17/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__